module.exports = __webpack_public_path__ + "docs/overview-04ca7d.md";